import { CompetitionList } from '~/apis/ssf';
import { Skeleton } from '~/components/Skeleton/Skeleton';
import { useCompetitionLevelListQuery } from '~/pages/level/queries';

interface Props {
  competition: Pick<CompetitionList, 'category'>;
}

export function CompetitionCategory({ competition }: Props) {
  const { data, isLoading } = useCompetitionLevelListQuery();

  if (isLoading) {
    return <Skeleton style={{ width: '95px', height: '16px' }} />;
  }

  const result = data?.find(d => d.name === competition.category);

  if (!result) {
    return competition.category;
  }

  return result.description;
}
